import axios from 'axios';
import * as endpoints from './const';

class RelocationApi {
  static getVehicles(fetchParams) {
    return axios
      .get(endpoints.RELOCATION_VEHICLES, {
        params: fetchParams,
      })
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  static getVehicleDetails(fetchParams) {
    return axios
      .get(endpoints.RELOCATION_VEHICLE_DETAILS, {
        params: fetchParams,
      })
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  static changeVehicleCostcenter(country, data) {
    return axios
      .post(
        `${endpoints.RELOCATION_VEHICLES_CHANGE}?countryCode=${country}`,
        data
      )
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  }

  static getAvailableCostCenter(
    country,
    companyCode,
    lookup = '',
    offset = 0,
    limit = 25
  ) {
    const query = [
      `countryCode=${encodeURIComponent(country)}`,
      `companyCode=${encodeURIComponent(companyCode)}`,
      `limit=${limit}`,
      `offset=${offset}`,
    ];

    if (lookup && lookup.length > 0) {
      query.push(`lookup=${encodeURIComponent(lookup)}`);
    }

    return axios
      .get(`${endpoints.RELOCATION_VEHICLE_AVAILABLE_CC}?${query.join('&')}`)
      .then(response => ({ ...response.data, offset }))
      .catch(error => {
        throw error;
      });
  }
}

export default RelocationApi;



// WEBPACK FOOTER //
// ./src/api/RelocationApi.js